function fitImage(e)
{
    var element = getElement(e);

    if(element.originalSize.width > element.originalSize.height) {
        if(type == 'vierkant' || type == 'rond') {
            element.size(null, canvasHeight);
        }else{
            if(canvasHeight > canvasWidth) {
                element.size(null, canvasHeight);
            }else{
                element.size(canvasWidth, null);
            }
        }
    } else {
        if(type == 'vierkant' || type == 'rond') {
            element.size(canvasWidth, null);
        }else{
            if(canvasHeight > canvasWidth) {
                element.size(null, canvasHeight);
            }else{
                element.size(canvasWidth, null);
            }
        }
    }

    centerElement(element);
}


function addImageMenu()
{
    var html = $('.markup-image').html(),
        $menu = $(html),
        $parent = $menu.closest('.afbeelding-plaatsen-container');

    $parent.attr('data-index', index++);

    $('.image-blok .afbeelding-plaatsen-container').last().before($menu);
    setImageText();
}

function setImageText() {
    $('.image-blok .afbeelding-plaatsen-titel').each(function(index){
        $(this).text('Afbeelding ' + (index + 1));
    });
}

function upload($element)
{
    var url = $element.data('url');
    $element.fileupload({
        url: url,
        dataType: 'json',
        add: function(e, data) {
            $.fancybox('<h1>Een ongenblik geduld</h1><p>Een ogenblik geduld, uw bestand wordt verwerkt.</p>');
            data.submit();
        },
        done: function (e, data) {
            var file = data.result.files[0];

            if(file.url){
                var image = draw.image(file.url).loaded(function(loader) {
                    var width = 300;
                    var factor = loader.width / width;
                    var height = loader.height / factor;
                    this.size(width, height);
                    this.originalSize = loader;
                    this.preserveAspectRatio = "xMidYMid meet";
                });
                image.resize();
                elements.push(image);

                setEvents(image);
                setSelectOnClick(image);
                addImageMenu();
                $.fancybox.close();
            }

        }
    }).prop('disabled', !$.support.fileInput)
        .parent().addClass($.support.fileInput ? undefined : 'disabled');
}

function convertToDataURLviaCanvas(url, callback, outputFormat){
    var img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = function(){
        var canvas = document.createElement('CANVAS');
        var ctx = canvas.getContext('2d');
        var dataURL;
        canvas.height = this.height;
        canvas.width = this.width;
        ctx.drawImage(this, 0, 0);
        dataURL = canvas.toDataURL(outputFormat);
        callback(dataURL);
        canvas = null;
    };
    img.src = url;
}
